<p-tabView>
    <p-tabPanel header="Comment Category">
        <app-workspace-comment-category [reloadCategory]="reloadCategory" ></app-workspace-comment-category>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel" appendTo="body">
        <ng-template pTemplate="header">
            <p-menu #configmenuWorkspace id="config_menu_workspace" [model]="configMenuItems" [popup]="true"
                appendTo="body">
            </p-menu>
            <span class="btnBars p-mr-0" (click)="configmenuWorkspace.toggle($event)">
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>
<app-add-update-comment-category *ngIf="displayCreateUpdateCommentCategory"
  [displayCreateUpdateCommentCategory]="displayCreateUpdateCommentCategory"
  [isEditMode]="isEditMode"
  [showParentCategory]="true"
  (hideCreateUpdateCategory)="hideCreateUpdateCategory($event)"
  (refreshCategory)="refreshCategory($event)"
  >
</app-add-update-comment-category>


